// ----------------------------------------------------------------------

export default function Container(theme) {
    return {
        MuiContainer: {
            styleOverrides: {
                maxWidthLg: {
                    paddingLeft: "30px !important",
                    paddingRight: "30px !important"
                }
            }
        }
    };
}
